import React from 'react';
import Modal from 'Shared/components/Modal';
import VerifyCriticalInformationForm from './VerifyCriticalInformationForm';
import {ValidApplication, InvalidApplication} from 'ApplicationEntry/models/Application';

type VerifyCriticalInformationModalProps = {
  hideModal: () => void;
  application: ValidApplication | InvalidApplication;
};

export const VerifyCriticalInformationModal = (props: VerifyCriticalInformationModalProps) => {
  const {application, hideModal} = props;

  return (
    <Modal title="Verify Critical Information" open onClose={hideModal} disableBackdropClick>
      <VerifyCriticalInformationForm
        application={application}
        onCancel={() => hideModal()}
        onSaveToLife70={() => hideModal()}
      />
    </Modal>
  );
};

export default VerifyCriticalInformationModal;
